<template>
    <div class="points-link container">
        <div class="row h-50 py-3">
            <div class="col my-4">
                <h2 class="message">Paste or enter a link or address you'd like to check in the field below.</h2>
                <label class="message" for="phone">Address or URL</label>
                <input class="form-control"
                        id="address"
                        v-model="address"
                        type="text"
                        name="address">
                <div class="form-group">
                    <label class="message" for="platformSelection">Select Platform</label>
                    <select class="form-control" id="platformSelection">
                        <option>ios</option>
                        <option>android</option>
                    </select>
                </div>
            </div>
            <div class="col-12">
                <div class="row text-center">
                    <div class="col py-3" style="text-align: center">
                    <button class="ty-button" v-on:click="sendInput">Submit</button>
                </div>
                <div class="col py-3" style="text-align: center">
                    <button class="clear-button" v-on:click="clearInput">Clear</button>
                </div>
                </div>
            </div>
            <div class="col-12">
                <div v-if="response === null && !loading">
                    <p>Once you submit a value, the results from the service will show here.</p>
                </div>
                <div v-if="response === null && loading">
                    <p>Loading...</p>
                </div>
                <div v-else>
                    <p>{{response}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "PointsInput",
    data: function(){
      return{
        errors: [],
        loading:false,
        address:null,
        response:null,
        platform:null
      }
    },
    methods: {
      sendInput: function () {
          this.loading = true
            const API_URL = {
                AWS:"http://13.56.151.152:3000",
                HEROKU:"https://oa-poi-helper.herokuapp.com/"
            }
            //Sources: ios or android
            const data = {
                "text": this.address,
                "source": this.platform || "ios"
            }
            fetch(API_URL.HEROKU, {
                method: 'post',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then((response) => {
                return response.json();
            }).then((data) => {
                this.response = data || "process complete"
                this.loading = false
            });
      },
      clearInput: function () {
          this.response = null
          this.address = null
          this.loading = false
      }
    }
  }
</script>

<style scoped>
    a {
        color:#FFFFFF;
    }
    .points-link{
        background-color: #217CF6;
    }
    .message{
        color:#FFFFFF;
    }
    .ty-button{
        background: #D92429;
        border-radius: 0px;
        width:343px;
        height:64px;
        font-family: ToyotaType-Semibold;
        font-size: 24px;
        color: #FFFFFF;
        letter-spacing: 0.73px;
        text-align: center;
    }
    .clear-button{
        background: darkgrey;
        border-radius: 0px;
        width:343px;
        height:64px;
        font-family: ToyotaType-Semibold;
        font-size: 24px;
        color: #FFFFFF;
        letter-spacing: 0.73px;
        text-align: center;
    }
</style>
